import {Inject, Injectable} from '@angular/core';
import {Observable, from} from 'rxjs';

import {ConfigService} from '../../config/config.service';
import {EsriRequest} from '../../config/esri.module';
import {LineInfo} from '../model/lineInfo.model';
import {LayerContainerService} from './layer-container.service';
import {QueryService} from './query.service';
import {ErrorHandlingService} from '../../core/service/error-handling.service';

@Injectable({
  providedIn: 'root'
})
export class LineInfoService {

  constructor(@Inject(ErrorHandlingService) private _errorService: ErrorHandlingService,
              @Inject(ConfigService) private _configService: ConfigService,
              @Inject(LayerContainerService) private _layerContainerService: LayerContainerService,
              @Inject(QueryService) private _queryService: QueryService) {
  }

  public getLineInfo(geometry: __esri.Geometry, linienNr?: number): Observable<any> {
    const url: string = this._configService.getLayerUrl('lineinfo');
    // const points: string = this.convertToPoints(geometry);
    const options: __esri.RequestOptions = {
      query: {
        geometry: JSON.stringify(geometry),
        forcedLineNumber: linienNr,
        maxbuffer: 1000,
        f: 'json'
      },
      responseType: 'json'
    };

    return from(
      new Promise((resolve, reject) => {
        EsriRequest(url, options)
          .then((result: any) => {
            if (result.data.Status === 400) {
              resolve(result.data);
            }
            const m = ((result.data.strecken[0].KM_BIS - result.data.strecken[0].KM_VON) / 2 + result.data.strecken[0].KM_BIS).toFixed(0);
            // convert result to line info model
            const lineInfo: LineInfo = {
              lineNumber: result.data.strecken[0].KILOMETRIERUNGSLINIE,
              km: m,
              km_von: result.data.strecken[0].KM_VON,
              km_bis: result.data.strecken[0].KM_BIS
            };
            resolve(lineInfo);
          })
          .catch((error) => {
            this._errorService.handleSoeError(error);
            reject(error);
          });
      }));
  }

}
